/**
 * Gets the category label from the first breadcrumb.
 *
 * @param {Object} params - Parameters for getting the category.
 * @param {Array} [params.breadCrumbs=[]] - The breadcrumbs array (optional).
 * @returns {string} The category label from the first breadcrumb, or empty string if not available.
 */
export const getCategory = ({ breadCrumbs = [] }) => {
  return breadCrumbs?.[0]?.label || '';
};

/**
 * Generates the description for a collection page.
 *
 * @param {Object} params - Parameters for generating the description.
 * @param {string} [params.category=''] - The category label (optional).
 * @param {string} [params.name=''] - The collection name (optional).
 * @returns {string} The generated description for the collection page, or a default description if insufficient data.
 */
export const generateCollectionDesc = ({ category, name }) => {
  const defaultCategory = category ? `${category} Department` : 'our products';
  const defaultName = name || 'space';
  return `Shop our ${defaultCategory} to customize your ${defaultName} today at The Home Depot`;
};

/**
 * Generates the SEO title for a collection page.
 *
 * @param {Object} params - Parameters for generating the title.
 * @param {string} [params.brandName=''] - The brand name (optional).
 * @param {string} [params.category=''] - The category label (optional).
 * @param {string} [params.name=''] - The collection name (optional).
 * @param {string} [params.type=''] - The collection type (optional).
 * @returns {string} The generated SEO title.
 */
export const generateCollectionTitle = ({ brandName, category, name, type }) => {
  const suffix = 'The Home Depot';
  const prefix = type === 'Space'
    ? [name, category].filter(Boolean).join(' - ')
    : [brandName, name].filter(Boolean).join(' ');
  return [prefix, suffix].filter(Boolean).join(' - ');
};